import React, { useState } from 'react';
import { ButtonToolbar, DropdownButton } from 'react-bootstrap';
import PropTypes from 'prop-types';
import $ from 'jquery';

import RangeCalendar from '../../../../../../components/DatePickers/Range';

const DropdownSubMenuWithDate = ({ element, minDate, maxDate, filters, pullRight, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    isOpen ? $('#datePicker').data('daterangepicker').show() : $('#datePicker').data('daterangepicker').hide();
    setIsOpen((prev) => !prev);
  };

  const onMouseEnter = () => {
    $('#datePicker').data('daterangepicker').show();
    setIsOpen(true);
  };

  const onApply = (date) => {
    onSelect(element.code, date);
  };

  return (
    <li className="dropdown-submenu calendar-wrap" onMouseEnter={onMouseEnter}>
      <ButtonToolbar className={`dropdown-submenu-${pullRight ? 'left' : 'right'}`}>
        <DropdownButton open={isOpen} onToggle={() => ({})} pullRight={pullRight} title={element.title} id="dropdown-submenu-btn" onClick={toggle} />
        <RangeCalendar
          onApply={onApply}
          defStartDate={filters?.date_range_filter_settings?.default_from}
          defEndDate={filters?.date_range_filter_settings?.default_to}
          parentEl=".calendar-wrap"
          opens={pullRight ? 'left' : 'right'}
          minDate={minDate}
          maxDate={maxDate}
          linkedCalendars={false}
          hidden
          showDropdowns
        />
      </ButtonToolbar>
    </li>
  );
};

DropdownSubMenuWithDate.propTypes = {
  element: PropTypes.any,
  minDate: PropTypes.string,
  maxDate: PropTypes.string,
  filters: PropTypes.any,
  pullRight: PropTypes.bool,
  onSelect: PropTypes.func,
};

export default DropdownSubMenuWithDate;
